<template>
  <ThreadList
    ref="threadListRef"
    :enable-scroll-load="false"
    :on-pull-load="reload"
  >
    <div class="px-4 mt-2">
      <div class="flex flex-col gap-2">
        <VanEmpty v-if="list.length === 0" :description="$t('memory.empty')" />
        <div
          v-else
          v-for="memory in list"
          :key="memory.id"
          class="flex items-center"
        >
          <div v-if="isSelect">
            <VanCheckbox
              :model-value="include.includes(memory.id)"
              @click.stop="clickItem(memory)"
            />
          </div>
          <MateMemoryItem
            class="flex-1"
            :memory="memory"
            :is-select="isSelect"
            :include="include"
            @reload="reload"
            @click="clickItem(memory)"
          />
        </div>
      </div>
    </div>
  </ThreadList>
</template>

<script setup lang="ts">
import { readMateMemoryPage } from "@/apis/mate";
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { MemoryType } from "@/enums/mateEnums";
import { MateMemory } from "@/types/entity";
import { onMounted, ref } from "vue";

const props = defineProps<{
  mateId: number;
  include: number[];
  isSelect?: boolean;
}>();

const emit = defineEmits<{
  (e: "select", memory: MateMemory): void;
}>();

const list = ref<MateMemory[]>([]);
const threadListRef = ref<ThreadListInstance>();

const reload = async () => {
  const { page } = await readMateMemoryPage({
    filter: {
      mateId: props.mateId,
      type: MemoryType.Scene,
    },
    pagination: {
      page: 1,
      perPage: 999,
    },
  });

  list.value = page.data;
};

const clickItem = (memory: MateMemory) => {
  if (props.isSelect) {
    emit("select", memory);
  }
};

onMounted(() => {
  reload();
});
</script>
